import React from 'react';
import NetworkCalculator from './NetworkCalculator';

const App: React.FC = () => <NetworkCalculator />;

export default App;
// Falls CRA noch meckert: ganz unten zusätzlich:
export {};
